import { Contact, ContactType } from 'typings'

export interface Token {
    token: string
}

export interface RecoverPasswordState {
    username?: string
    token?: Token
    contact?: Contact
    contacts?: Contact[]
    phone?: string
    email?: string
}

export interface ChangePasswordInfoInput {
    username?: string
    token?: string
    newPassword?: string
}

export interface MessageChangePasswordData {
    messageChangePassword: {
        phone: string
        email: string
        message: string
    }
}

export interface SendResetTokenData {
    sendResetToken: {
        status: string
    }
}

export interface OTPTokenData {
    generateKeyOtp: {
        key: string
    }
}

export interface ChangePasswordData {
    changePassword: {
        message: string
    }
}

export interface ViewerLogin {
    viewerSearchLoginByCPF: {
        mobile: string
        email: string
    }
}

export interface PatientToken {
    userName: string
    token: string
}

export interface PatienTokenResponse {
    checkToken: {
        message: string
    }
}

export enum RecoverStep {
    selectContact = 0,
    validateToken = 1,
    newPassword = 2,
}

export interface Contacts extends Array<Contact> {}

export interface ContactToReset {
    id?: number
    type?: ContactType
    value?: string
}

export interface AuthenticateOtp {
    authenticateOtp: {
        access_token: string
        refresh_token: string
    }
}
